// What the admin panel can point an announcement at. The app defines these; an announcement names one by id.
// An anchor that isn't in this build of the app is simply never found, so its tooltip never shows.

// Buttons and rows (tooltip, "Mới" label). `dot`: the element has room for a "Mới" label.
export const ANCHORS = [
  { id: 'meal_ingredients', label: 'Chi tiết bữa ăn · nguyên liệu theo bảng thành phần thực phẩm (sửa khối lượng)' },
  { id: 'feedback_button', label: 'Mọi màn chính (cá nhân và HLV) · nút Góp ý nổi' },
  { id: 'plan_arrange', label: 'Thực đơn – chi tiết tuần · nút Sắp xếp' },
  { id: 'plan_week_options', label: 'Thực đơn – chi tiết tuần · nút ⋯', dot: true },
  { id: 'plan_create', label: 'Thực đơn · nút Tạo mới' },
  { id: 'plan_cook_option', label: 'Thực đơn · Tạo thực đơn tuần · lựa chọn "Nấu chung với một người"', dot: true },
  { id: 'plan_cook_row', label: 'Thực đơn – chi tiết tuần · ⋯ · dòng Nấu chung', dot: true },
  { id: 'plan_takeout', label: 'Thực đơn – chi tiết tuần · nút Đặt ngoài (món đầu tiên của hôm nay)' },
  { id: 'day_takeout', label: 'Hôm nay · nút Đặt ngoài (bữa đầu tiên chưa ghi)' },
  { id: 'capture_button', label: 'Thanh dưới · nút chụp (Ghi lại)' },
  { id: 'account_button', label: 'Đầu trang · nút tài khoản', dot: true },
  { id: 'settings_target_history', label: 'Cài đặt · Lịch sử mục tiêu', dot: true },
  { id: 'mode_switch', label: 'Đầu trang · ảnh đại diện của HLV (chuyển chế độ) · chỉ HLV thấy', dot: true },
  { id: 'coach_mode_chip', label: 'Chế độ HLV · nút "Chế độ HLV" (chuyển chế độ) · chỉ HLV thấy' },
  { id: 'day_workout_tab', label: 'Hôm nay · tab Tập luyện' },
  { id: 'settings_reminders', label: 'Cài đặt · Nhắc nhở', dot: true },
  { id: 'settings_schedule', label: 'Cài đặt · Lịch tập với Coach', dot: true },
  { id: 'settings_my_coach', label: 'Cài đặt · Huấn luyện viên của tôi', dot: true },
  { id: 'settings_coach_mode', label: 'Cài đặt · Dành cho huấn luyện viên', dot: true },
  { id: 'coach_schedule_add', label: 'Chế độ HLV · Kế hoạch → Lịch tập · nút + Thêm lịch · chỉ HLV thấy' },
  { id: 'coach_schedule_share', label: 'Chế độ HLV · Kế hoạch → Lịch tập · nút Chia sẻ lịch tuần · chỉ HLV thấy', dot: true },
  { id: 'coach_offline_add', label: 'Chế độ HLV · Chọn học viên · nút + Thêm người chưa dùng app · chỉ HLV thấy', dot: true },
];

// Screens that can carry a banner at the top.
export const SCREENS = [
  { id: 'home', label: 'Trang chủ' },
  { id: 'day', label: 'Hôm nay' },
  { id: 'plan', label: 'Thực đơn' },
  { id: 'trends', label: 'Thống kê' },
  { id: 'settings', label: 'Cài đặt' },
];

// Where "Thử ngay" can lead.
export const LINKS = [
  { path: '/', label: 'Trang chủ' },
  { path: '/day', label: 'Hôm nay' },
  { path: '/plan', label: 'Thực đơn' },
  { path: '/trends', label: 'Thống kê' },
  { path: '/settings', label: 'Cài đặt' },
  { path: '/targets', label: 'Lịch sử mục tiêu' },
  { path: '/profile', label: 'Hồ sơ' },
  { path: '/credits', label: 'Lượt AI' },
  { path: '/support', label: 'Góp ý (mở khung chat)' },
  { path: '/schedule', label: 'Lịch tập với Coach' },
  { path: '/settings/notifications', label: 'Cài đặt nhắc nhở' },
  { path: '/my-coach', label: 'Huấn luyện viên của tôi' },
  { path: '/coach/intro', label: 'Dành cho huấn luyện viên' },
];

export const KINDS = [
  { id: 'tooltip', label: 'Tooltip gắn nút', hint: 'Tính năng mới ở một nút cụ thể. Hiện khi người dùng mở đúng màn đó.' },
  { id: 'dot', label: 'Nhãn "Mới"', hint: 'Tính năng nhỏ, hoặc trong menu ⋯ hay Cài đặt. Mất khi chạm vào, hoặc sau 14 ngày.' },
  { id: 'whats_new', label: 'Sheet "Có gì mới"', hint: 'Bản cập nhật lớn có 2–3 tính năng. Hiện một lần ở Trang chủ.' },
  { id: 'banner', label: 'Banner trong trang', hint: 'Tính năng cần người dùng chủ động bật. Có nút ✕.' },
];

export const AUDIENCES = [
  { id: 'all', label: 'Tất cả' },
  { id: 'free', label: 'Chỉ gói Miễn phí' },
  { id: 'pro', label: 'Chỉ Pro (cả dùng thử)' },
  { id: 'new', label: 'Người dùng mới (dưới 14 ngày)' },
  { id: 'existing', label: 'Người dùng cũ (từ 14 ngày)' },
];

// The native app's version (written into its page by bin/build-native); the website is always current.
export const APP_VERSION = typeof window !== 'undefined' ? window.MACRO_MATE_NATIVE?.appVersion ?? null : null;
